import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "General", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const update = (k, v) => setForm(prev => ({ ...prev, [k]: v }));
  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/contact", form);
      toast.success("Message received. We'll reach out within 1 working day.");
      setForm({ name: "", email: "", phone: "", subject: "General", message: "" });
    } catch (_e) {
      toast.error("Could not submit. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 lg:px-8 py-16" data-testid="contact-page">
      <div className="text-xs uppercase tracking-wider text-teal-700 font-semibold mb-3">Contact</div>
      <h1 className="text-4xl font-semibold text-slate-900">We'd love to hear from you.</h1>
      <p className="mt-5 text-slate-600">Have a question about a loan, partnership or a grievance? Drop us a note.</p>
      <Card className="p-6 mt-8 border-slate-200">
        <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="c-name">Your name</Label>
            <Input id="c-name" data-testid="contact-name" value={form.name} onChange={e => update("name", e.target.value)} required />
          </div>
          <div>
            <Label htmlFor="c-email">Email</Label>
            <Input id="c-email" data-testid="contact-email" type="email" value={form.email} onChange={e => update("email", e.target.value)} required />
          </div>
          <div>
            <Label htmlFor="c-phone">Phone</Label>
            <Input id="c-phone" data-testid="contact-phone" value={form.phone} onChange={e => update("phone", e.target.value)} />
          </div>
          <div>
            <Label htmlFor="c-subject">Subject</Label>
            <Input id="c-subject" data-testid="contact-subject" value={form.subject} onChange={e => update("subject", e.target.value)} />
          </div>
          <div className="md:col-span-2">
            <Label htmlFor="c-msg">Message</Label>
            <Textarea id="c-msg" data-testid="contact-message" rows={5} value={form.message} onChange={e => update("message", e.target.value)} required />
          </div>
          <div className="md:col-span-2 flex justify-end">
            <Button type="submit" disabled={submitting} className="bg-slate-900 hover:bg-slate-800" data-testid="contact-submit-btn">
              {submitting ? "Sending…" : "Send message"}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
}
